import { render, staticRenderFns } from "./AdminLinkClicks.vue?vue&type=template&id=5713a44a&scoped=true"
import script from "./AdminLinkClicks.vue?vue&type=script&lang=js"
export * from "./AdminLinkClicks.vue?vue&type=script&lang=js"
import style0 from "./AdminLinkClicks.vue?vue&type=style&index=0&id=5713a44a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5713a44a",
  null
  
)

export default component.exports